import { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { HStack, VStack } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import { Modal } from "../../../components/core/basic/Modal";
import { useUpload } from "../../uploads/api/useUpload";
import { isTerminalStatus } from "../../uploads/constants";
import { StatusBadge } from "../../uploads/StatusBadge";
import { UploadStatusView } from "../../uploads/UploadStatusView";
import { UploadForm } from "./UploadForm";

export const PriceLinkUploadModal = NiceModal.create(({ uploadId }: { uploadId?: number }) => {
  const modal = useModal();
  const { t } = useTranslation(["pricingv2"]);
  const [activeUploadId, setActiveUploadId] = useState(uploadId);
  const { data: upload } = useUpload(activeUploadId);

  const isProcessing = !!activeUploadId && !!upload && !isTerminalStatus(upload.status);

  return (
    <Modal
      isOpen={modal.visible}
      isDismissable={!isProcessing}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isProcessing) {
          modal.remove();
        }
      }}
      title={
        <HStack gap="medium" alignItems="center">
          <span>{t(($) => $.pricingv2["Upload Price Links"])}</span>
          {upload && <StatusBadge status={upload.status} />}
        </HStack>
      }
      css={{ minWidth: "800px" }}
    >
      <VStack
        gap="large"
        alignItems="stretch"
        paddingY="xlarge"
        paddingX="xlarge"
        overflow="auto"
        minHeight="0"
        flex="1"
      >
        <p className={css({ color: "gray.600", fontSize: "small" })}>
          {t(
            ($) =>
              $.pricingv2[
                "Price Links automatically match follower SKU prices to a leader SKU whenever the leader's price changes."
              ],
          )}
        </p>
        {activeUploadId ?
          <UploadStatusView
            uploadId={activeUploadId}
            onClose={() => modal.remove()}
            successMessage={t(($) => $.pricingv2["Your price links have been successfully uploaded and processed."])}
            confirmationPhrase="upload price links"
            showUploadsPageLink={false}
          />
        : <UploadForm onUploadCreated={setActiveUploadId} />}
      </VStack>
    </Modal>
  );
});
